<template>
  <c-alert
    v-if="isDemo"
    type="warning"
  >
    Извините, но данная возможность не поддерживается в демонстрационном режиме.
  </c-alert>
</template>

<script>
import CAlert from '../../../../../../resources/js/components/ui/CAlert'
import { mapGetters } from 'vuex'

/**
 * @deprecated
 */
export default {
  name: 'DemoDenied',
  components: { CAlert },
  computed: {
    ...mapGetters({
      isDemo: 'seo/client/info/isDemo'
    })
  }
}
</script>
